import { PlanV2 } from "@zapier/checkout/esm/types";

export const getIncludedMeteredTasks = (plan: Omit<PlanV2, "__typename">) => {
  const tiers = plan.tiers;
  const freeTier = tiers.find(tier => tier.pricePerTask === 0);
  const planNumFreeMeteredTasks = freeTier ? freeTier.numTasks : 0;

  return planNumFreeMeteredTasks;
};
